import { render, staticRenderFns } from "./GB_form.vue?vue&type=template&id=79fcf562&"
import script from "./GB_form.vue?vue&type=script&lang=js&"
export * from "./GB_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports